var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEditAlt = function SvgIconEditAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.835 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.835 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.861,18a2.745,2.745,0,0,0-1.955.81L35.3,23.419A4.4,4.4,0,0,0,34,26.551v2.074h2.074a4.4,4.4,0,0,0,3.13-1.3l4.611-4.611A2.765,2.765,0,0,0,41.861,18Zm.7,3.467-4.609,4.609a2.639,2.639,0,0,1-1.879.779h-.3v-.3a2.639,2.639,0,0,1,.777-1.879l4.611-4.611a.994.994,0,1,1,1.4,1.4Z",
    transform: "translate(-30.623 -18)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.623,35.115h7.87a2.623,2.623,0,0,0,2.623-2.623v-3.5H29.368v3.5a.874.874,0,0,1-.874.874h-7.87a.874.874,0,0,1-.874-.874V24.623a.874.874,0,0,1,.874-.874h3.5V22h-3.5A2.623,2.623,0,0,0,18,24.623v7.869A2.623,2.623,0,0,0,20.623,35.115Z",
    transform: "translate(-18 -21.115)",
    fill: "#f6c866"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEditAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit-alt.ff21ca28.svg";
export { ForwardRef as ReactComponent };